<template>
  <div class="block-change">
    <div class="block-header">
      <a href="#" class="left-c">
        <img class="mb logo" src="../assets/images/logo_mb.png" alt="logo.png" />
        <img class="pc logo2" src="../assets/images/logo2.png" alt="logo2.png" />
      </a>
      <a href="#" class="pc">
        <img src="../assets/images/logo.png" class="logo" alt="logo.png" />
      </a>
      <div class="right-c">
        <div class="language">
          <div class="language-text" @click="langSwitch">
            {{ $i18n.locale == 'en' ? '繁體中文' : 'English' }}
          </div>
        </div>
        <div class="menu-icon" @click="
          menuShow = !menuShow;">
          <img src="../assets/images/menu.png" alt="menu.png" />
        </div>
        <div class="menu-list" :class="{ show: menuShow }">
          <ul class="link-list">
            <li class="link-item" :class="{ checked: menuIndex == 0 }" @click="switchIndex(0)">
              <a href="#home" @click.prevent="scrollDom('homeDom')">
                {{ $t("new.1") }}
              </a>
            </li>
            <li class="link-item" :class="{ checked: menuIndex == 1 }" @click="switchIndex(1)">
              <a href="#about" @click.prevent="scrollDom('aboutDom')">
                {{ $t("new.2") }}
              </a>
            </li>
            <li class="link-item" :class="{ checked: menuIndex == 2 }" @click="switchIndex(2)">
              <a href="#service" @click.prevent="scrollDom('serviceDom')">
                {{ $t("new.3") }}
              </a>
            </li>
            <li class="link-item" :class="{ checked: menuIndex == 3 }" @click="switchIndex(3)">
              <a href="#qa" @click.prevent="scrollDom('qaDom')">
                {{ $t("new.4") }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="top-wrapper">
      <div class="section1" id="home" ref="homeDom">
        <div class="animation wow bounceInUp" >
          <img src="../../public/logo.png" class="mask_logo" srcset="">
        </div>
        <div class="text-box wow bounceInUp" >
          <div class="text1" style="font-style: italic;" v-if="$i18n.locale == 'en'">
            {{ $t("new.7") }}
          </div>
          <div class="text1" v-else>
            {{ $t("new.7") }}
          </div>
          <div class="title up" v-if="$i18n.locale == 'en'">
            {{ $t("new.8") }} <span> {{ $t("new.8_2") }}</span><br />
            {{ $t("new.8_3") }} <span> {{ $t("new.8_4") }}</span>
          </div>
          <div class="title titlezh up" style="font-weight:bold" v-else>
            {{ $t("new.8") }} <span> {{ $t("new.8_2") }}</span><br />
            {{ $t("new.8_3") }} <span> {{ $t("new.8_4") }}</span>
          </div>
          <div class="desc up" style="font-style: italic;" v-if="$i18n.locale == 'en'">
            {{ $t("new.9") }}
          </div>
          <div class="desc up" v-else>
            {{ $t("new.9") }}
          </div>
        </div>
        <div class="btn-box wow bounceInUp" >
          <a :href="tglink" class="link-btn link-btn1"  v-show="$i18n.locale == 'zh'">
            <img src="../assets/images/icon1.png" alt="icon1.png" />
            <span>了解更多</span>
          </a>
          <a :href="tglink" class="link-btn link-btn1"  v-show="$i18n.locale == 'en'">
            <img src="../assets/images/icon1.png" alt="icon1.png" />
            <span>Learn more</span>
          </a>
          <a href="https://tool.blockchange.dev" class="link-btn link-btn2" v-show="$i18n.locale == 'zh'">
            <img src="../assets/images/icon2.png" alt="icon2.png" />
            <span>我們的工具</span>
          </a>
          <a href="https://tool.blockchange.dev" class="link-btn link-btn2" v-show="$i18n.locale == 'en'">
            <img src="../assets/images/icon2.png" alt="icon2.png" />
            <span>Our Instruments</span>
          </a>
        </div>
        <div class="param-list wow bounceInUp"   v-show="$i18n.locale == 'zh'">
          <div class="param-item">
            <span class="val">30 + </span>
            <span class="name">團隊成員</span>
          </div>
          <div class="param-item">
            <span class="val">50 + </span>
            <span class="name">成功項目</span>
          </div>
          <div class="param-item">
            <span class="val">100 + </span>
            <span class="name">綜合經驗</span>
          </div>
        </div>
        <div class="param-list wow bounceInUp"   v-show="$i18n.locale == 'en'">
          <div class="param-item">
            <span class="val">30 + </span>
            <span class="name">Teammates</span>
          </div>
          <div class="param-item">
            <span class="val">50 + </span>
            <span class="name">Projects</span>
          </div>
          <div class="param-item">
            <span class="val">100 + </span>
            <span class="name">Experience</span>
          </div>
        </div>
      </div>
      <div class="section2" id="about" ref="aboutDom">
        <div class="ball_canvas">
          <canvas id="canvas" :width="canvasWidth" :height="canvasHeight"></canvas>
        </div>
        <div class="title up wow bounceInUp" >
          {{ $t("new.15") }} <span>{{ $t("new.15_2") }}</span>
        </div>
        <div class="pc wow bounceInUp" >
          <div class="desc" v-if="$i18n.locale == 'en'">
            {{ $t("new.16")
            }}<span>{{ $t("new.16_2") }}</span></br>
            <span>{{ $t("new.16_3") }}</span></br>{{ $t("new.16_4") }}
          </div>
          <div class="desc" v-else>
            {{ $t("new.16")
            }}<span class="bold">{{ $t("new.16_2") }}</span></br>是
            <span class="bold">{{ $t("new.16_3") }}</span>{{ $t("new.16_4") }}
          </div>
        </div>
        <div class="mb wow bounceInUp" >
          <div class="desc">
            {{ $t("new.16")
            }}<span>{{ $t("new.16_2") }}</span>
            <span>{{ $t("new.16_3") }}</span>{{ $t("new.16_4") }}
          </div>
        </div>

        <div class="introduct-link wow bounceInUp" >
          <div class="introduct-item">
            <div class="text1">
              {{ $t("new.17") }}<span>{{ $t("new.17_2") }}</span>{{ $t("new.17_3") }}
              <span>{{ $t("new.17_4") }}</span>
            </div>
          </div>
          <div class="introduct-item introduct-item2">
            <div>
              <div class="title up">
                <img src="../assets/images/icon4.png" alt="icon4.png" />
                <span>{{ $t("new.18") }}</span>
              </div>
              <div class="text2">
                {{ $t("new.19") }}
              </div>
              <div class="text3">
                {{ $t("new.20") }}
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="bottom-wrapper">
      <div class="section3" id="service" ref="serviceDom">
        <div class="title up wow bounceInUp" >
          {{ $t("new.21") }} <span style="color:#6FCF97">{{ $t("new.21_2") }}</span>
        </div>
        <div class="desc up wow bounceInUp" >
          {{ $t("new.22") }}
        </div>
        <div class="icon-list">
          <div class="icon-item  wow bounceInUp" >
            <img class="normal" src="../assets/images/s3_logo/icon1.png" alt="icon1.png" />
            <img class="hover" src="../assets/images/s3_logo/icon1a.png" alt="icon1a.png" />
            <div class="m-title">
              {{ $t("new.23") }}
            </div>
            <div class="m-desc">
              {{ $t("new.24") }}
            </div>
          </div>
          <div class="icon-item  wow bounceInUp" >
            <img class="normal" src="../assets/images/s3_logo/icon2.png" alt="icon2.png" />
            <img class="hover" src="../assets/images/s3_logo/icon2a.png" alt="icon2a.png" />
            <div class="m-title">
              {{ $t("new.25") }}
            </div>
            <div class="m-desc">
              {{ $t("new.26") }}
            </div>

          </div>
          <div class="icon-item  wow bounceInUp" >
            <img class="normal" src="../assets/images/s3_logo/icon3.png" alt="icon3.png" />
            <img class="hover" src="../assets/images/s3_logo/icon3a.png" alt="icon3a.png" />
            <div class="m-title">
              {{ $t("new.27") }}
            </div>
            <div class="m-desc">
              {{ $t("new.28") }}
            </div>
          </div>
          <div class="icon-item  wow bounceInUp" >
            <img class="normal" src="../assets/images/s3_logo/icon4.png" alt="icon4.png" />
            <img class="hover" src="../assets/images/s3_logo/icon4a.png" alt="icon4a.png" />
            <div class="m-title">
              {{ $t("new.29") }}
            </div>
            <div class="m-desc">
              {{ $t("new.30") }}
            </div>
          </div>
          <div class="icon-item  wow bounceInUp" >
            <img class="normal" src="../assets/images/s3_logo/icon5.png" alt="icon5.png" />
            <img class="hover" src="../assets/images/s3_logo/icon5a.png" alt="icon5a.png" />
            <div class="m-title">
              {{ $t("new.31") }}
            </div>
            <div class="m-desc">
              {{ $t("new.32") }}
            </div>
          </div>
          <div class="icon-item  wow bounceInUp" >
            <img class="normal" src="../assets/images/s3_logo/icon6.png" alt="icon6.png" />
            <img class="hover" src="../assets/images/s3_logo/icon6a.png" alt="icon6a.png" />
            <div class="m-title">
              {{ $t("new.33") }}
            </div>
            <div class="m-desc">
              {{ $t("new.34") }}
            </div>
          </div>
          <div class="icon-item wow bounceInUp" >
            <img class="normal" src="../assets/images/s3_logo/icon7.png" alt="icon7.png" />
            <img class="hover" src="../assets/images/s3_logo/icon7a.png" alt="icon7a.png" />
            <div class="m-title">
              {{ $t("new.35") }}
            </div>
            <div class="m-desc">
              {{ $t("new.36") }}
            </div>

          </div>
          <div class="icon-item wow bounceInUp" >
            <img class="normal" src="../assets/images/s3_logo/icon8.png" alt="icon8.png" />
            <img class="hover" src="../assets/images/s3_logo/icon8a.png" alt="icon8a.png" />
            <div class="m-title">
              {{ $t("new.37") }}
            </div>
            <div class="m-desc">
              {{ $t("new.38") }}
            </div>
          </div>
          <div class="icon-item wow bounceInUp" >
            <img class="normal" src="../assets/images/s3_logo/icon9.png" alt="icon9.png" />
            <img class="hover" src="../assets/images/s3_logo/icon9a.png" alt="icon9a.png" />
            <div class="m-title">
              {{ $t("new.39") }}
            </div>
            <div class="m-desc">
              {{ $t("new.40") }}
            </div>
          </div>
        </div>
      </div>
      <div class="section4">
        <div class="title up wow bounceInUp" >
          {{ $t("new.41") }} <span style="color:#6FCF97">{{ $t("new.41_2") }}</span>
        </div>
        <div class="desc up wow bounceInUp" >
          {{ $t("new.42") }}
        </div>
        <div class="left-c">
          <div class="pic-wrapper">
            <div class="s4_pic1">
              <img src="../assets/images/s4_pic/status1/1.jpg" alt="1.jpg" />
              <img class="hide" src="../assets/images/s4_pic/status2/1.jpg" alt="1.jpg" />
            </div>
            <div class="s4_pic2">
              <img src="../assets/images/s4_pic/status1/2.jpg" alt="2.jpg" />
              <img class="hide" src="../assets/images/s4_pic/status2/2.jpg" alt="2.jpg" />
            </div>
            <div class="s4_pic3">
              <img src="../assets/images/s4_pic/status1/3.jpg" alt="3.jpg" />
              <img class="hide" src="../assets/images/s4_pic/status2/3.jpg" alt="3.jpg" />
            </div>
            <div class="s4_pic4">
              <img src="../assets/images/s4_pic/status1/4.jpg" alt="4.jpg" />
              <img class="hide" src="../assets/images/s4_pic/status2/4.jpg" alt="4.jpg" />
            </div>
            <div class="s4_pic5">
              <img src="../assets/images/s4_pic/status1/5.jpg" alt="5.jpg" />
              <img class="hide" src="../assets/images/s4_pic/status2/5.jpg" alt="5.jpg" />
            </div>
            <div class="s4_pic6">
              <img src="../assets/images/s4_pic/status1/6.jpg" alt="6.jpg" />
              <img class="hide" src="../assets/images/s4_pic/status2/6.jpg" alt="6.jpg" />
            </div>
            <div class="s4_pic7">
              <img src="../assets/images/s4_pic/status1/7.jpg" alt="7.jpg" />
              <img class="hide" src="../assets/images/s4_pic/status2/7.png" alt="7.jpg" />
            </div>
            <div class="s4_pic8">
              <img src="../assets/images/s4_pic/status1/8.jpg" alt="8.jpg" />
              <img class="hide" src="../assets/images/s4_pic/status2/8.jpg" alt="8.jpg" />
            </div>
            <div class="s4_pic9">
              <img src="../assets/images/s4_pic/status1/9.jpg" alt="9.jpg" />
              <img class="hide" src="../assets/images/s4_pic/status2/9.jpg" alt="9.jpg" />
            </div>
          </div>
        </div>
        <div class="right-c" id="screen">

        </div>
        <!-- <div class="right-c">
              <div class="bubble-list">
                <div class="bubble-item bubble-1" v-html="$t('new.43')"></div>
                <div class="bubble-item bubble-2">
                  {{ $t("new.44") }}
                </div>
                <div class="bubble-item bubble-3">
                  {{ $t("new.45") }}
                </div>
                <div class="bubble-item bubble-4">
                  {{ $t("new.47") }}
                </div>
                <div class="bubble-item bubble-5" v-html="$t('new.49')"></div>
                <div class="bubble-item bubble-6">
                  {{ $t("new.48") }}
                </div>
                <div class="bubble-item bubble-7" v-html="$t('new.46')"></div>
                <div class="bubble-item bubble-8">
                  {{ $t("new.50") }}
                </div>
                <div class="bubble-item bubble-9">
                  {{ $t("new.51") }}
                </div>
                <div class="bubble-item bubble-10">
                  {{ $t("new.52") }}
                </div>
              </div>
            </div> -->
      </div>
    </div>
    <div>
      <div class="section5">
        <div class="server-wrapper">
          <div class="left-c wow bounceInUp" >
            <div class="title up">
              {{ $t("new.53") }}
            </div>
            <div class="desc up">
              {{ $t("new.54") }}
            </div>
          </div>
          <div class="right-c wow bounceInUp" >
            <img src="../assets/images/s5_pic1.png" alt="s5_pic1.png" />
          </div>
        </div>
        <div class="partners wow bounceInUp" >
          <div class="partners-wrapper">
            <div class="title">
              {{ $t("new.55") }}
            </div>
            <div class="partners-box">
              <moveImg :data="dataList" :class-option="optionLeft" class="seamless-warp2" ref="moveImg">
                <div class="partners-list">
                  <div class="partners-item" v-for="(item, index) in dataList" :key="index" :data-index="index"
                    @mouseenter="enter" @mouseleave="leave" @touchstart="touchStart" @touchmove="touchMove"
                    @touchend="touchEnd">
                    <img :src="item.normal" class="normal" alt="1.png" />
                    <img :src="item.active" class="hover" alt="1.png" />
                  </div>
                </div>
              </moveImg>
            </div>
          </div>
        </div>
      </div>
      <div class="section6" id="qa" ref="qaDom">
        <div class="section6-wrapper">
          <div class="title up wow bounceInUp" >
            {{ $t("new.56") }}
          </div>
          <div class="desc up wow bounceInUp" >
            {{ $t("new.57") }}
          </div>
          <div class="qs-wrapper wow bounceInUp" >
            <div class="qs-item" :class="{ open: item.open }" @click="item.open = !item.open"
              v-for="(item, index) in quesData" :key="index">
              <div class="qs-question">
                <span>{{ $t('new.' + item.question) }}</span>
                <div class="extend-wrap">
                  <img class="open" src="../assets/images/+.png" alt="" />
                  <img class="close" src="../assets/images/-.png" alt="" />
                </div>
              </div>
              <div class="qs-answer">
                {{ $t('new.' + item.answer) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="section6_bg"></div>
      <div class="footer_warpper">
        <div class="left-c">
          <div class="logo_wrapper">
            <img class="logo-pic" src="../assets/images/logo.png" alt="logo.png" />
            <img class="logo2" src="../assets/images/logo2.png" alt="logo2.png" />
          </div>
          <div class="text2" v-if="$i18n.locale == 'en'">
            {{ $t("new.58_2") }}
          </div>
          <div class="text" v-else>
            <span style="color: #6fcf97;">{{ $t("new.58") }}</span>{{ $t("new.58_2") }}
          </div>
        </div>
        <div class="right-c">
          <div class="right-c-main">
            <div class="top-box">
              <span class="pc">{{ $t("new.59") }}</span>
              <div class="icon-list">
                <a :href="tglink">
                  <img src="../assets/images/icon14.png" alt="icon14.png" />
                </a>
                <a href="https://twitter.com/BlockChange_" style="margin-left: 27px;">
                  <img src="../assets/images/icon15.png" alt="icon15.png" />
                </a>
              </div>
            </div>
            <a href="mailto:Support@BlockChange.Dev" class="email">
              <div class="bottom-box">
                <img src="../assets/images/icon16.png" alt="icon16.png" />
                <span class="bold" style="color:#6FCF97">{{ $t("new.60") }}</span>&nbsp;<span>{{ $t("new.60_2") }}</span>
              </div>
            </a>
            <div class="mb">
              <div class="icon-list">
                <a :href="tglink" style="    font-size: 0;">
                  <img src="../assets/images/icon14.png" alt="icon14.png" />
                </a>
                <a href="https://twitter.com/BlockChange_" style="margin-left: 10px;font-size: 0;">
                  <img src="../assets/images/icon15.png" alt="icon15.png" />
                </a>
              </div>
            </div>
          </div>
          <div class="copy-right">Copyright © 2023 Block Change</div>
        </div>
      </div>
    </div>
  </div>
</template>
	
	
<script>
import "../assets/css/default.less";
import { WOW } from "wowjs";
import moveImg from "../components/moveImg.vue";

var num = 10; //定义生成小球数目
var minSpeed = 1; //小球最小速度
var maxSpeed = 3; //小球最大速度

function random(min, max) {
  return ~~(Math.random() * (max - min) + min);
}
//创建一个小球的对象
function Ball(text, width, height, innerWidth, innerHeight) {
  this.init(text, width, height, innerWidth, innerHeight);
}
Ball.prototype = {
  init: function (text, width, height, innerWidth, innerHeight) {
    console.log(text);
    //给小球添加私有属性
    this.speedX = random(minSpeed, maxSpeed);
    this.speedY = random(minSpeed, maxSpeed);
    this.div = document.createElement("div");
    this.div.className = "ball";

    this.div.style.backgroundImage = "url(s4_bg.png)";
    this.div.style.backgroundSize = "cover";
    this.div.style.width = width + "px";
    this.div.style.height = height + "px";
    this.div.innerHTML = text;
    // this.div.style.backgroundColor = '#' + Math.floor(Math.random() * 0xffffff).toString(16);
    this.x = random(0, innerWidth - width);
    this.y = random(0, innerHeight - height);
    this.width = width;
    this.height = height;
  },
}; //造小球
export default {
  components: {
    moveImg,
  },
  data() {
    return {
      isShow: true,
      isShow2: false,
      menuShow: false,
      menuIndex: 0,
      dataList: [
        {
          normal: require("../assets/images/partner/p1.png"),
          active: require("../assets/images/partner/p1a.png"),
        },
        {
          normal: require("../assets/images/partner/p2.png"),
          active: require("../assets/images/partner/p2a.png"),
        },
        {
          normal: require("../assets/images/partner/p3.png"),
          active: require("../assets/images/partner/p3a.png"),
        },
        {
          normal: require("../assets/images/partner/p4.png"),
          active: require("../assets/images/partner/p4a.png"),
        },
        {
          normal: require("../assets/images/partner/p5.png"),
          active: require("../assets/images/partner/p5a.png"),
        },
        {
          normal: require("../assets/images/partner/p6.png"),
          active: require("../assets/images/partner/p6a.png"),
        },
        {
          normal: require("../assets/images/partner/p7.png"),
          active: require("../assets/images/partner/p7a.png"),
        },
        {
          normal: require("../assets/images/partner/p8.png"),
          active: require("../assets/images/partner/p8a.png"),
        },
        {
          normal: require("../assets/images/partner/p9.png"),
          active: require("../assets/images/partner/p9a.png"),
        },
      ],
      quesData: [
        {
          question: "q1",
          answer: "a1",
          open: false,
        },
        {
          question: "q2",
          answer: "a2",
          open: false,
        },
        {
          question: "q3",
          answer: "a3",
          open: false,
        },
        {
          question: "q4",
          answer: "a4",
          open: false,
        },
      ],
      topShow: false,
      imgUrl1: true,
      imgUrl2: false,

      innerWidth: null,
      innerHeight: null,
      list: [
        {
          width: 100,
          height: 100,
        },
        {
          width: 120,
          height: 120,
        },
        {
          width: 80,
          height: 80,
        },
        {
          width: 140,
          height: 140,
        },
        {
          width: 100,
          height: 100,
        },
        {
          width: 100,
          height: 100,
        },
        {
          width: 140,
          height: 140,
        },
        {
          width: 100,
          height: 100,
        },
        {
          width: 100,
          height: 100,
        },
        {
          width: 140,
          height: 140,
        },
      ],
      aBall: [], //定义一个数组来接受小球
      canvasWidth: 0,
      canvasHeight: 0,
    };
  },
  computed: {
    optionLeft() {
      return {
        step: 0.8,
        direction: 2, // 0向下 1向上 2向左 3向右
        // limitMoveNum: this.dataList.length,// 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true,
        openTouch: false,
      };
    },
    tglink() {
      let name = this.$route.params.name || "BC_BlockChange";
      return "https://t.me/" + name;
    },
  },
  methods: {
    scrollDom(refD) {
      window.scrollTo({
        //滚动到元素位置
        //top: this.$refs[元素].offsetTop,//offsetTop 相对于offsetparent 定位,当有定位时，不准确。
        top: this.$refs[refD].getBoundingClientRect().top + window.scrollY, //推荐使用，getBoundingClientRect 相对于当前视口的位置
        //top: 400//滚动到指定距离
        //top: 0,//滚动到顶部
        //top: document.documentElement.scrollHeight,//滚动到底部
        behavior: "smooth", // 平滑滚动
      });
    },
    enter() {
      console.log("enter1");
      this.$refs.moveImg.enter();
    },
    leave() {
      console.log("leave1");
      this.$refs.moveImg.leave();
    },
    touchStart() {
      console.log("touchStart1");
      this.$refs.moveImg.enter();
    },
    touchMove() {
      console.log("touchMove1");
    },
    touchEnd() {
      console.log("touchEnd1");
      this.$refs.moveImg.leave();
    },
    draw(obj) {
      obj.div.style.top = obj.y + "px";
      obj.div.style.left = obj.x + "px";
    },
    updata(obj) {
      obj.x = obj.div.offsetLeft + obj.speedX;
      obj.y = obj.div.offsetTop + obj.speedY;
      if (obj.x < 0) {
        obj.x = 0;
        obj.speedX *= -1;
      }
      if (obj.y < 0) {
        obj.y = 0;
        obj.speedY *= -1;
      }
      if (obj.x > this.innerWidth - obj.width) {
        obj.x = this.innerWidth - obj.width;
        obj.speedX *= -1;
      }
      if (obj.y > this.innerHeight - obj.height) {
        obj.y = this.innerHeight - obj.height;
        obj.speedY *= -1;
      }
    },
    move() {
      for (var i = 0, len = this.aBall.length; i < len; i++) {
        this.draw(this.aBall[i]);
        this.updata(this.aBall[i]);
      }
      requestAnimationFrame(this.move);
    },
    switchBallText() {
      for (var i = 0, len = this.list.length; i < len; i++) {
        console.log(this.aBall[i], this.$t("ball." + (i + 1)));
        this.aBall[i].div.innerHTML = this.$t("ball." + (i + 1));
      }
    },
    switchIndex(index) {
      this.menuIndex = index;
      this.menuShow = false;
    },
    langSwitch() {
      if (this.$i18n.locale == "en") {
        localStorage.setItem("lang", "zh");
        this.$i18n.locale = "zh";
      } else {
        localStorage.setItem("lang", "en");
        this.$i18n.locale = "en";
      }
      // window.location.reload()
      this.switchBallText();
      this.menuShow = false;
    },
    toBottom() {
      document.documentElement.scrollTop =
        document.documentElement.scrollHeight;
    },
    toTop() {
      document.documentElement.scrollTop = 0;
    },
    scrollHander() {
      this.menuShow = false;
      let top =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (top > 1400) {
        this.topShow = true;
      } else {
        this.topShow = false;
      }
    },
    sleep1(numberMillis) {
      var now = new Date();
      var exitTime = now.getTime() + numberMillis;
      while (true) {
        now = new Date();
        if (now.getTime() > exitTime) return;
      }
    },
  },
  mounted() {
    var wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true,
      live: true,
    });
    wow.init();
    this.innerWidth = document.getElementById("screen").clientWidth;
    this.innerHeight = document.getElementById("screen").clientHeight;
    console.log(this.innerWidth);

    var canvasWidth = 1000;
    var canvasHeight = 700;
    var originX = 400;
    var originY = 150;
    var langAxis = 450;
    var shortAxis = 220;

    if (this.innerWidth < 750) {
      for (var i = 0; i < this.list.length; i++) {
        this.list[i].width = this.list[i].width - 20;
        this.list[i].height = this.list[i].height - 20;
      }
      canvasWidth = 350;
      canvasHeight = 400;
      originX = 50;
      originY = 50;
      langAxis = 50;
      shortAxis = 80;
    }
    this.canvasWidth = canvasWidth;
    this.canvasHeight = canvasHeight;
    for (var i = 0; i < this.list.length; i++) {
      var ball = new Ball(
        this.$t("ball." + (i + 1)),
        this.list[i].width,
        this.list[i].height,
        this.innerWidth,
        this.innerHeight
      );
      document.getElementById("screen").appendChild(ball.div);
      this.aBall.push(ball);
    } //小球运动
    this.move();
    var R = 6;
    var time = 0;

    var canvas = document.getElementById("canvas");
    var cxt = canvas.getContext("2d");

    //定义运动的小球
    var m1 = new Image();

    m1.src = "./ball.png";

    var ballArr = [{ img: m1, x: 0, y: 0, rad: 0 }];

    //画椭圆函数
    function drawEls(flag) {
      // 添加线性渐变线
      var grd = cxt.createLinearGradient(200, 300, 600, 300);
      var distance = 0,
        distancey = 0;
      if (flag) {
        distance = 150;
        distancey = 150;
      }
      // 添加颜色断点
      grd.addColorStop(0, "rgba(20, 255, 230, 0)");
      grd.addColorStop(0.8, "rgba(20, 255, 230, 0)");
      grd.addColorStop(1, "rgba(64, 129, 255, 0.2)");
      // console.log(flag)
      cxt.strokeStyle = grd; //"rgba(64, 129, 255, 0.3)";
      cxt.lineWidth = 2;
      var step = 1 / 450;
      cxt.beginPath();
      cxt.moveTo(originX + distance + langAxis, originY + distancey);
      for (let i = 0; i < 2 * Math.PI; i += step) {
        cxt.lineTo(
          originX + distance + langAxis * Math.cos(i),
          originY + distancey + shortAxis * Math.sin(i)
        );
      }
      cxt.closePath();
      cxt.stroke();
    }
    //画小球运动
    function drawAnimation(steps, stopRad) {
      cxt.clearRect(0, 0, canvasWidth, canvasHeight);
      drawEls(); //画椭圆
      drawEls(1); //画椭圆
      steps = steps || 1; //步长
      var step = langAxis > shortAxis ? 1 / langAxis : 1 / shortAxis;
      step *= steps; //加速
      time += step;

      var balllength = ballArr.length;
      var k = 0.2 / 100; //近大远小效果的参数
      var c = 0.4;
      for (let i = 0; i < balllength; i++) {
        //计算每个小球的起始角度
        ballArr[i].rad = 2 * Math.PI;
        //计算小球中心位置坐标
        ballArr[i].x = originX + langAxis * Math.cos(time + ballArr[i].rad);
        ballArr[i].y = originY + shortAxis * Math.sin(time + ballArr[i].rad);
        //小球运动轨迹
        cxt.drawImage(
          ballArr[i].img,
          originX +
            langAxis * Math.cos(time + ballArr[i].rad) -
            R * (ballArr[i].y * k + c), //为使小球中心在线上，减掉小球半径
          originY +
            shortAxis * Math.sin(time + ballArr[i].rad) -
            R * (ballArr[i].y * k + c),
          2 * R * (ballArr[i].y * k + c),
          2 * R * (ballArr[i].y * k + c)
        );
      }
    }
    if (this.running) {
      clearInterval(this.running);
      this.running = null;
    }
    this.running = setInterval(function () {
      drawAnimation();
    }, 1000 / 60);

    window.addEventListener("scroll", this.scrollHander);
  },
  destroyed() {
    if (this.running) {
      clearInterval(this.running);
      this.running = null;
    }
    window.removeEventListener("scroll", this.scrollHander);
  },
};
</script>


<style lang="less"></style>

	
	